
export const originEnum = {
  default : 'yalo'
}